var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":""}},[_c('span',[_vm._v("© 2019 Imersys")])])
}
var staticRenderFns = []

export { render, staticRenderFns }